module.exports = __webpack_public_path__ + "img/index.a4b2656.png";